var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"name",attrs:{"fluid":"","id":"helloWorldComponent"}},[_c('h1',{attrs:{"id":"hello"}}),_c('h2',{attrs:{"id":"titles"}})])}
var staticRenderFns = []

export { render, staticRenderFns }